import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const VatContext = createContext({
  vatEnabled: true,
  vatRate: 0.15,
  loading: true,
  refreshVatSetting: () => {},
});

export const VatProvider = ({ children }) => {
  const [vatEnabled, setVatEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  const fetchVatSetting = async () => {
    try {
      const response = await axios.get(`${API}/settings/vat-enabled`);
      setVatEnabled(response.data.vat_enabled);
    } catch (error) {
      console.error("Error fetching VAT setting:", error);
      setVatEnabled(true); // Default to enabled on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVatSetting();
  }, []);

  const value = {
    vatEnabled,
    vatRate: vatEnabled ? 0.15 : 0,
    loading,
    refreshVatSetting: fetchVatSetting,
  };

  return <VatContext.Provider value={value}>{children}</VatContext.Provider>;
};

export const useVat = () => {
  const context = useContext(VatContext);
  if (!context) {
    throw new Error("useVat must be used within a VatProvider");
  }
  return context;
};

export default VatContext;
